export enum PackagingTerms {
	AExpendablePackaging = 0,
	BJlrOwnedDurablePackaging = 10,
	CSupplierOwnedDurablePackaging = 20,
	LThirdPartyLeased = 30,
}
